import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { cx } from "../lib/cx";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger" | "danger-solid" | "link";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: "md" | "sm";
  icon?: ReactNode;
  /** Botão só com ícone: exige `label` para leitores de tela. */
  iconOnly?: boolean;
  label?: string;
  loading?: boolean;
  block?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "secondary", size = "md", icon, iconOnly, label, loading, block, className, children, disabled, type, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type ?? "button"}
      className={cx(
        "vx-btn",
        variant !== "secondary" && `vx-btn--${variant}`,
        size === "sm" && "vx-btn--sm",
        iconOnly && "vx-btn--icon",
        block && "vx-btn--block",
        className,
      )}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      aria-label={iconOnly ? label : rest["aria-label"]}
      title={iconOnly ? label : rest.title}
      {...rest}
    >
      {loading ? <span className="vx-spin" aria-hidden="true" /> : icon}
      {iconOnly ? null : children}
    </button>
  );
});
